// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Tooltip_tooltipContainer__YB-UC","tooltip":"Tooltip_tooltip__0fAcB"};